import { useTranslation } from 'react-i18next';

import ModalAlert from 'components/UI/Modal/ModalAlert/ModalAlert';

interface IStopVoiceCampaignModal {
	onConfirm: () => void;
	toggleStopModal: () => void;
	stopsChildCampaigns: boolean;
}

const StopVoiceCampaignModal = ({ onConfirm, toggleStopModal, stopsChildCampaigns }: IStopVoiceCampaignModal) => {
	const { t } = useTranslation(['common', 'pages']);

	return (
		<ModalAlert
			closeBtnLabel={t('common:cancel')}
			confirmBtnLabel={t('common:continue')}
			description={t(
				stopsChildCampaigns
					? 'pages:voiceCampaign.stopModal.parentDescription'
					: 'pages:voiceCampaign.stopModal.description'
			)}
			heading={t('pages:voiceCampaign.stopModal.heading')}
			isConfirmBtnDisabled={false}
			isOpen
			onClose={toggleStopModal}
			onConfirm={onConfirm}
			width='25rem'
		/>
	);
};

export default StopVoiceCampaignModal;
